import React from 'react';
import createReactClass from 'create-react-class';
import NavigationActionCreator from 'action_creators/navigation';
import CheckoutSummary from 'views/plugins/checkout/summary';
import MessageGuide from 'views/plugins/checkout/message_guide';
import PrivacyPolicy from 'views/plugins/checkout/privacy_policy';
import StoreInterestMixin from 'lib/flux/store/interest_mixin';
import { findLocale } from 'services/translation';
import { injectIntl } from 'react-intl';
import BookingRequestActionCreator from 'action_creators/booking_request';
import ModalActionCreator from 'action_creators/modal';
import PaymentError from 'views/plugins/global_error/PaymentError';
import Dimmer from 'views/shared/ui/dimmer';
import _ from 'underscore';
import CheckoutHeader from '../header';
import Cover from '../cover';
import Submit from '../submit';
import { triggerStripe3dsScroll } from '../../../utils/scroll_utils';
import './index.scss';
// eslint-disable-next-line import/order
import { triggerCheckoutStepScroll } from 'views/plugins/checkout/utils/scroll_utils';
import { trackCheckoutMobileArriveOnPage } from '../segmentTracking';

const CheckoutSummaryScreen = createReactClass({
  displayName: 'CheckoutSummaryScreen',
  mixins: [StoreInterestMixin],

  componentDidMount() {
    const {
      flags,
      booking_request_id: bookingRequestId,
      fields,
      tour_id: tourId,
      tour,
    } = this.props;

    triggerCheckoutStepScroll();
    trackCheckoutMobileArriveOnPage({
      flags,
      bookingRequestId: bookingRequestId || fields?.get('id'),
      tourId,
      guideId: tour?.guide_id,
      guideName: tour?.guide_name,
      pageName: 'Checkout Summary',
    });
  },

  componentDidUpdate(prevProps, prevState) {
    const { stripeAuthLoading } = this.state;
    if (this._requiresAuth(prevState) && !stripeAuthLoading) {
      triggerStripe3dsScroll();
      this.handleStripeAuth();
    } else if (this._readyForConfirmation()) {
      const { is_booking_invoice } = prevProps;
      const langParam = `&lang=${findLocale()}`;
      const { pluginSlug } = this.props;
      const pluginParam = pluginSlug ? `&plugin=${pluginSlug}` : '';
      /* payments path shows partner branding on standalone (non-plugin) payment flows */
      const confirmationUrl = is_booking_invoice
        ? `/payments/${this.props.booking_request_id}/confirmation`
        : `/booking_request/confirmation?id=${
            this.props.booking_request_id
          }${langParam}${this._getCuratedToursListParam()}${pluginParam}`;
      window.location = confirmationUrl;
    }
  },

  getInitialState() {
    return {
      currency: '',
      unit_price: 0,
      customer_form_fields: {},
      billing_form_fields: {},
      requiresAuth: false,
      authCompleted: false,
      stripeCardElement: null,
      customerSecret: null,
      paymentId: null,
      stripeAuthLoading: false,
    };
  },

  getStoreInterests() {
    return {
      currency: 'pricing.currency',
      unit_price: 'pricing.unit_price',
      customer_form_fields: 'pricing.customer_form_fields',
      billing_form_fields: 'pricing.billing_form_fields',
      privacy_policy_link: 'pricing.privacy_policy_link',
      privacy_policy_link_text: 'pricing.privacy_policy_link_text',
      authCompleted: 'booking_request.authCompleted',
      paidInFull: 'booking_request.paidInFull',
    };
  },

  _googleTagCompleteCheckoutEvent() {
    const { booking_request_id, tour, tour_id, total, is_ga4_enabled } =
      this.props;
    const { currency, unit_price, customer_form_fields, billing_form_fields } =
      this.state;
    const form_fields = Object.assign(
      {},
      customer_form_fields.toJS(),
      billing_form_fields.toJS()
    );
    try {
      googleTagManagerCompleteCheckout(
        booking_request_id,
        total,
        currency.toUpperCase(),
        tour_id,
        tour.name,
        unit_price,
        form_fields,
        is_ga4_enabled
      );
    } catch (error) {
      console.log('google tag error', error);
    }
  },

  _requiresAuth(prevState) {
    return this.props.requiresAuth === true && !this.props.authCompleted;
  },

  handleStripeAuth() {
    this.setState({ stripeAuthLoading: true });
    try {
      stripe
        .handleCardPayment(this.props.customerSecret)
        .then((result) => {
          this.setState({ stripeAuthLoading: false });
          if (result.error) {
            BookingRequestActionCreator.setStripePaymentError(
              result.error.message
            );
            NavigationActionCreator.transitionTo(
              'Views.Plugins.Checkout.Mobile.Screens.CheckoutPayment'
            );
          } else {
            const { status } = result.paymentIntent;
            const params = {
              id: this.props.paymentId,
              status,
            };
            BookingRequestActionCreator.completeAuth(params);
          }
        })
        .catch((error) => {
          this.setState({ stripeAuthLoading: false });
          console.log(error);
        });
    } catch (error) {
      this.setState({ stripeAuthLoading: false });
      console.log(error);
    }
  },

  _getCuratedToursListParam() {
    // Returns name of CTL if plugin is in that context
    const originUrl = new URLSearchParams(window.location.search).get(
      'origin_url'
    );
    if (originUrl) {
      const originUrlSplit = originUrl.split('/');
      const indexOfCtl = originUrlSplit.indexOf('curated-list');
      return indexOfCtl !== -1
        ? `&ctl_name=${originUrlSplit[indexOfCtl + 1]}`
        : '';
    }
    return '';
  },

  _readyForConfirmation() {
    const { authCompleted, paidInFull } = this.state;
    if (authCompleted || paidInFull) return true;

    return this.props.committed === true;
  },

  // Partner has edited/added paid addons to a guest booked, free tour
  _guestBookedFreeTourWithPaidAddons() {
    const { partner_booked } = this.props.summary_props.request;
    const { total, unit_price } = this.state;

    return (
      !partner_booked && parseFloat(unit_price) == 0 && parseFloat(total) > 0
    );
  },

  onEditDetailsClicked() {
    NavigationActionCreator.transitionTo(
      'Views.Plugins.Checkout.Mobile.Screens.BookingInitial',
      {
        fromSummary: true,
      }
    );
  },

  _summaryProps() {
    return _.extend(this.props.summary_props, {
      onEditDetailsClicked: this.onEditDetailsClicked,
    });
  },

  _messageGuideProps() {
    return _.extend({}, this.props, {
      showHint: this.props.includes_transport,
    });
  },

  _coverProps() {
    return {
      forInvoice: this.props.forInvoice,
      tourPicture: this.props.tour.picture,
      guideAvatar: this.props.tour.guide_avatar,
      tourName: this.props.tour.name_translation,
      guideName: this.props.tour.guide_name,
      hasResource: this.props.has_resource,
      resourceName: this.props.resource_name,
    };
  },

  _privacyPolicyProps() {
    return _.extend({}, this.props, {
      privacy_policy_accepted: this.props.privacy_policy_link,
      guide_privacy_policy_text: this.props.privacy_policy_link_text,
    });
  },

  renderPaymentError() {
    ModalActionCreator.show({
      content: (
        <PaymentError
          errorMessage={this.props.errors.get('stripePaymentError')}
        />
      ),
      className: 'small GlobalError-Modal-Plugin modal',
      settings: { closable: true },
      showIcon: true,
    });
    BookingRequestActionCreator.resetStripeAuth();
  },

  translatedSubmitLabel() {
    const {
      tour: {
        settings: { submit_booking_label },
      },
      intl,
    } = this.props;
    const label = submit_booking_label.value;

    return label === 'Confirm Purchase'
      ? intl.formatMessage({
          id: 'CONFIRM_PURCHASE',
          defaultMessage: 'Confirm Purchase',
        })
      : label ||
          intl.formatMessage({
            id: 'CONFIRM_PURCHASE',
            defaultMessage: 'Confirm Purchase',
          });
  },

  render() {
    const {
      timer,
      intl,
      isAffiliate,
      privacy_policy_link,
      privacy_policy_link_text,
      onCommit,
      confirmation_subtext,
      errors,
    } = this.props;
    const { stripeAuthLoading } = this.state;

    return (
      <div className="CheckoutSummaryScreen">
        <Dimmer fixed loader active={stripeAuthLoading} />
        <CheckoutHeader
          title={intl.formatMessage({
            id: 'REVIEW_AND_CONFIRM',
            defaultMessage: 'Review and Confirm',
          })}
        />
        <article className="transition-ctx">
          <Cover {...this._coverProps()} />
          {timer}
          <CheckoutSummary {...this._summaryProps()} />
          {!isAffiliate && <MessageGuide {...this._messageGuideProps()} />}
          {privacy_policy_link && privacy_policy_link_text && (
            <PrivacyPolicy {...this._privacyPolicyProps()} />
          )}
          <Submit
            dataTestProp="mobile-checkout-summary"
            label={this.translatedSubmitLabel()}
            onSubmit={onCommit}
          />
          <p className="hint confirmation-subtext">{confirmation_subtext}</p>
        </article>
        {errors.get('stripePaymentError') && this.renderPaymentError()}
      </div>
    );
  },
});

export default injectIntl(CheckoutSummaryScreen);
